import { render, staticRenderFns } from "./ORTOverview.vue?vue&type=template&id=5e8f3d3c&scoped=true"
import script from "./ORTOverview.vue?vue&type=script&lang=js"
export * from "./ORTOverview.vue?vue&type=script&lang=js"
import style0 from "./ORTOverview.vue?vue&type=style&index=0&id=5e8f3d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f3d3c",
  null
  
)

export default component.exports